let elementsInViewport = [].slice.call( document.querySelectorAll( '[data-inviewport]' ) );
let Observer;
let ObserverWithTreshold;
let offset;

function Constructor() {
	onElementHeightChange( document.body, function() {
		elementsInViewport = [].slice.call( document.querySelectorAll( '[data-inviewport]' ) );
		elementsInViewport.forEach( Element => {
			offset = Element && parseFloat( Element.getAttribute( 'data-threshold' ) ) || 0;

			if( offset > 0 && offset <= 1 ) {
				ObserverWithTreshold.observe( Element );
			} else {
				Observer.observe( Element );
			}
		});
	})
	if ( "IntersectionObserver" in window ) {
		Observer = new IntersectionObserver( observerCallback );

		elementsInViewport.forEach( Element => {
			offset = Element && parseFloat( Element.getAttribute( 'data-threshold' ) ) || 0;
			if( offset > 0 && offset <= 1 ) {
				ObserverWithTreshold = new IntersectionObserver( observerCallback, { threshold: offset } );
				ObserverWithTreshold.observe( Element );
			} else {
				Observer.observe( Element );
			}
		});
	} else {
		elementsInViewport.forEach( element => {
			element.classList.add( 'in--viewport' );
		});
	}
}

function observerCallback( entries, observer ) {
	entries.forEach( function( entry ) {
		if ( entry.isIntersecting ) {
			let Element = entry.target;
			let delay = Element && parseInt( Element.getAttribute( 'data-delay' ) ) || 0;

			if( delay ) {
				setTimeout( function() {
					Element.classList.add( 'in--viewport' );
				}, delay );
			} else {
				Element.classList.add( 'in--viewport' );
			}
			observer.unobserve( entry.target );
		}
	});
}

function onElementHeightChange( element, callback ) {
	var lastHeight = element.clientHeight;
	var newHeight;

	(function run() {
		newHeight = element.clientHeight;

		if ( lastHeight != newHeight && callback ) {
			setTimeout( function() {
				callback();
			}, 500 );
		}

		lastHeight = newHeight;

		if ( element.onElementHeightChangeTimer ) {
			clearTimeout( element.onElementHeightChangeTimer );
		}

		element.onElementHeightChangeTimer = setTimeout( run, 500);
	})();
}

export default Constructor